import { useQuery, gql } from '@apollo/client';
import { useAuth } from './AuthContext';

// Permiso "Operaciones" del usuario conectado: solo los superadmins que lo tienen ven la pantalla de Agentes.
// Se consulta a la base cada vez (el backend lo vuelve a controlar en cada operacion de los agentes).
export const MI_PERMISO_OPERACIONES = gql`query MiPermisoOperaciones { miPermisoOperaciones }`;

// Acceso a la pantalla Consumo: 'titular' (la ve completa), 'wallets' (solo las wallets) o null. Se consulta a la base.
export const MI_ACCESO_CONSUMO = gql`query MiAccesoConsumo { miAccesoConsumo }`;

export function useAccesoConsumo() {
  const { isAuthenticated } = useAuth();
  const { data, loading } = useQuery(MI_ACCESO_CONSUMO, { skip: !isAuthenticated, fetchPolicy: 'network-only' });
  return { acceso: (data && data.miAccesoConsumo) || null, cargando: !!(isAuthenticated && loading && !data) };
}

export function usePermisoOperaciones() {
  const { isSuperadmin } = useAuth();
  const { data, loading, refetch } = useQuery(MI_PERMISO_OPERACIONES, { skip: !isSuperadmin, fetchPolicy: 'network-only' });
  return { operaciones: !!(isSuperadmin && data?.miPermisoOperaciones), cargando: !!(isSuperadmin && loading && !data), refetch };
}
